import { Component, inject, input, OnInit, output, ɵINPUT_SIGNAL_BRAND_WRITE_TYPE } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UI_FORM_IMPORTS, ButtonComponent, SnackbarComponent, ToastType } from '@program-suite/ui';
import { LossRunReviewViewModel } from '@program-suite/data-common/program';
import { PendingRequestStore } from '../../data/pending-request.store';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'lib-loss-runs-form',
  templateUrl: './loss-runs-form.component.html',
  styleUrl: './loss-runs-form.component.scss',
  imports: [ReactiveFormsModule, ...UI_FORM_IMPORTS, ButtonComponent],
})
export class LossRunsFormComponent {
  model = input.required<LossRunReviewViewModel>();
  pendingRequestStore = inject(PendingRequestStore);
  closeModal = output<boolean>();
  form: FormGroup;

  constructor(private fb: FormBuilder, private snackbar: MatSnackBar) {
    this.form = this.fb.group({
      file: new FormControl(null, Validators.required),
      comments: new FormControl(null),
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const req = {
      ...this.form.value,
      id: this.model().lossRunRequestGuid,
    };
    var formData= new FormData();
    formData.append("id", req.id);
    formData.append("comments", req.comments);
    const files = this.form.get('file')?.value;
    formData.append("file", files[0]);
 

    this.pendingRequestStore
      .issueLossRunRequest(formData)
      .then(() => {
         this.closeModal.emit(true);
        this.snackbar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          data: { toastType: ToastType.Success, message: 'Loss Run Request successfully Issued' },
        });
      })
      .catch((error) => {
        this.snackbar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          data: {
            toastType: ToastType.Error,
            message: 'An error occurred.',
          },
        });
      }).finally(() => {
        this.pendingRequestStore.resource.reload();
        this.pendingRequestStore.setLossRunReview(null);
      });
  }

   
}
